import { countryCodes, countriesList } from "./countryCodes"

const Privacy = [
  {
    title: "Privacy",
    content:
      "<p>I have read and agree to the <a href='/privacy-policy' target='_blank'>Privacy Policy.</a></p>",
  },
  {
    title: "Interest",
    content:
      "<p>I would also like to receive industry information and show updates of events organised by Experia Events (Singapore Airshow, IMDEX Asia, Rotorcraft Asia and Unmanned Systems Asia).</p>",
    required: false,
  },
]

const PrivacyAlt = [
  {
    title: "Privacy",
    content:
      "<p>I would like to receive Singapore Airshow updates and industry information, and acknowledge that I have read and agree to the <a href='/privacy-policy' target='_blank'>Privacy Policy.</a></p>",
  },
  {
    title: "Interest",
    content:
      "<p>I would also like to receive industry information and show updates of events organised by Experia Events. (IMDEX Asia, Rotorcraft Asia and Unmanned Systems Asia)</p>",
    required: false,
  },
]

const Sales = [
  {
    title: "Directly",
    content: "<p>I have a sales enquiry. Please contact me directly.</a></p>",
  },
  {
    title: "Privacy",
    content:
      "<p>I have read and agree to the <a href='/privacy-policy' target='_blank'>Privacy Policy.</a></p>",
  },
  {
    title: "Interest",
    content:
      "<p>I would also like to receive industry information and show updates of events organized by Experia Events (e.g. Singapore Airshow, IMDEX Asia, Rotorcraft Asia, Unmanned Systems Asia)</p>",
    required: false,
  },
]

const PrivacySimple = [
  {
    title: "Privacy",
    content:
      "<p>I have read and agree to the <a href='/privacy-policy' target='_blank'>Privacy Policy.</a></p>",
  },
]

const PrivacySimpleTrade = [
  {
    title: "Privacy",
    content:
      "<p>I would like to receive Singapore Airshow updates and industry information, and acknowledge that I have read and agree to the <a href='/privacy-policy' target='_blank'>Privacy Policy.</a></p>",
  },
  {
    title: "Updates",
    content:
      "<p> I would also like to receive industry information and show updates of events organised by Experia Events. (IMDEX Asia, Rotorcraft Asia and Unmanned Systems Asia)",
  },
]

export const SignUpdates = {
  formName: "Sign-Up-Updates",
  checks: PrivacySimpleTrade,
  email: false,
  submission: "SUBSCRIBE NOW",
  cluster: [
    { title: "First Name", width: 30 },
    { title: "Last Name", width: 30 },
    { title: "Business Email", validation: "email", width: 30 },
    {
      title: "Country/Region of Work",
      width: 30,
    },
    { title: "Job Title", width: 30 },
    { title: "Company Name", width: 30 },
  ],
}

export const SignUpdatesPublic = {
  formName: "Sign-Up-Updates-Public",
  checks: PrivacySimple,
  email: false,
  submission: "SUBSCRIBE NOW",
  cluster: [
    { title: "First Name", width: 50 },
    { title: "Last Name", width: 50 },
    { title: "Email Address", validation: "email", width: 40 },
    {
      title: "Country of Work",
      width: 45,
    },
  ],
}

export const BookABoothContact = {
  formName: "Book-a-booth",
  submission: "BOOK A BOOTH",
  email: true,
  checks: Privacy,
  subName: "Requirements",
  subCluster: [
    {
      title: "length",
      width: 50,
      minSpace: ["36", "12"],
    },
    {
      title: "width",
      width: 50,
      minSpace: ["36", "12"],
    },
    {
      title: "scheme",
      type: "radio",
      options: ["Raw Space", "Standard Shell Scheme"],
    },
  ],
  clusterName: "Contact Person",
  cluster: [
    {
      title: "Salutation",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Dr.", label: "Dr." },
        { value: "Miss.", label: "Miss." },
        { value: "Ms.", label: "Ms." },
      ],
      width: 10,
      type: "dropdown",
    },
    { title: "First Name", width: 45 },
    { title: "Last Name", width: 45 },
    { title: "Company Name", width: 100 },
    { title: "Job Title", width: 50 },
    { title: "Business Email", validation: "email", width: 50 },
    {
      title: "Country/Region of Work",
      width: 40,
    },
    { title: "Country Code", width: 20 },
    { title: "Business Telephone No", width: 40, validation: "number" },
    {
      title: "Message (Optional)",
      required: false,
      width: 100,
      type: "textbox",
    },
  ],
}

export const Subscribe = {
  formName: "Subscribe",
  email: false,
  checks: PrivacyAlt,
  cluster: [
    {
      title: "Salutation",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Dr.", label: "Dr." },
        { value: "Miss.", label: "Miss." },
        { value: "Ms.", label: "Ms." },
      ],
      width: 10,
      type: "dropdown",
    },
    { title: "First Name", width: 45 },
    { title: "Last Name", width: 45 },
    { title: "Company Name", width: 100 },
    { title: "Job Title", width: 50 },
    { title: "Business Email", validation: "email", width: 50 },
    {
      title: "Country/Region of Work",
      width: 100,
    },
  ],
}

export const SubscribePublic = {
  formName: "Subscribe-Public",
  email: false,
  checks: PrivacySimple,
  cluster: [
    {
      title: "Salutation",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Dr.", label: "Dr." },
        { value: "Miss.", label: "Miss." },
        { value: "Ms.", label: "Ms." },
      ],
      width: 10,
      type: "dropdown",
    },
    { title: "First Name", width: 45 },
    { title: "Last Name", width: 45 },
    { title: "Email Address", validation: "email", width: 50 },
    {
      title: "Country",
      width: 50,
    },
  ],
}

export const SalesEnquiry = {
  formName: "SalesEnquiry",
  email: true,
  checks: Sales,
  cluster: [
    {
      title: "Salutation",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Dr.", label: "Dr." },
        { value: "Miss.", label: "Miss." },
        { value: "Ms.", label: "Ms." },
      ],
      width: 10,
      type: "dropdown",
    },
    { title: "First Name", width: 45 },
    { title: "Last Name", width: 45 },
    { title: "Company Name", width: 100 },
    { title: "Job Title", width: 50 },
    { title: "Email Address", validation: "email", width: 50 },
    {
      title: "Country of Work",
      width: 100,
    },
  ],
}

export const Download = {
  formName: "Download",
  email: false,
  checks: Privacy,
  cluster: [
    {
      title: "Salutation",
      options: [
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "Dr.", label: "Dr." },
        { value: "Miss.", label: "Miss." },
        { value: "Ms.", label: "Ms." },
      ],
      width: 10,
      type: "dropdown",
    },
    { title: "First Name", width: 45 },
    { title: "Last Name", width: 45 },
    { title: "Company Name", width: 100 },
    { title: "Job Title", width: 50 },
    { title: "Business Email", validation: "email", width: 50 },
    {
      title: "Country/Region of Work",
      width: 100,
    },
  ],
}
